<template>
    <div class="col-sm-6">
        <h6 class="mb-3 mt-4">Paroles maiņa</h6>
        <ValidationObserver ref="observer"
                            tag="form"
                            class="row"
                            @submit.prevent="submit">
            <div class="col-sm-8">
                <ValidationProvider v-show="!currPassword"
                                    tag="div"
                                    class="mb-4"
                                    mode="lazy"
                                    vid="currentPassword"
                                    :customMessages="{required: 'Norādi pašreizējo paroli.'}"
                                    rules="required"
                                    v-slot="{errors}">
                    <label for="currentPassword" class="d-block text-secondary text-left mb-0">Pašreizējā parole</label>
                    <input type="password" id="currentPassword" class="w-100 py-1 ds-input" v-model="currentPassword">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    class="mb-4"
                                    vid="newPassword"
                                    :bails="false"
                                    mode="eager"
                                    :rules="{
                                        min: 9,
                                        required: true,
                                        regex: passwordRegex,
                                        is_not: currentPassword,
                                    }"
                                    :customMessages="{
                                        min: 'Parolei jābut vismaz 9 simboliem.',
                                        required: 'Parole nevar būt tukša.',
                                        regex: 'Parolei jāsastāv no 1 lielā burta, 1 mazā burta, cipara, īpašā simbola (!@#$%?&^*).',
                                        is_not: 'Jaunai parolei ir jāatšķiras no pašreizējās',
                                    }"
                                    v-slot="{errors}">
                    <label for="newPassword" class="d-block text-secondary text-left mb-0">Jaunā parole</label>
                    <input type="password" id="newPassword" class="w-100 py-1 ds-input" v-model="newPassword">
                    <ul class="pl-3">
                        <li class="text-danger text-left small" v-for="error in errors" :key="error">{{ error }}</li>
                    </ul>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    class="mb-4"
                                    mode="eager"
                                    vid="confirmNewPassword"
                                    :rules="{
                                        required: true,
                                        is: newPassword,
                                    }"
                                    :customMessages="{required: 'Apstiprini jauno paroli.', is: 'Nesakrīt ar jauno paroli.'}"
                                    v-slot="{errors}">
                    <label for="confirmNewPassword" class="d-block text-secondary text-left mb-0">
                        Jaunās paroles apstiprinājums
                    </label>
                    <input type="password" id="confirmNewPassword" class="w-100 py-1 ds-input" v-model="confirmNewPassword">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <CustomButton class="w-100" btn-text="Mainīt paroli" :is-loading="isActiveRequest"/>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {required, regex, min, is, is_not} from 'vee-validate/dist/rules';
    import axios from 'axios';

    import CustomButton from '@/components/global/CustomButton';
    import {uiPasswordRegex} from '../../utils/password-generator';
    import { mapMutations} from 'vuex';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'user-password-change',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            currPassword: {
                type: String,
                default: '',
            },
            userData: {
                type: Object,
            }
        },
        data () {
            return {
                currentPassword: this.currPassword,
                newPassword: '',
                confirmNewPassword: '',
                isActiveRequest: false,
                passwordRegex: uiPasswordRegex,
                user: {...this.userData},
            }
        },
        created() {
            extend('required', required);
            extend('regex', regex);
            extend('min', min);
            extend('is', is);
            extend('is_not', is_not);
        },
        methods: {
             ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                this.isActiveRequest = true;

                try {
                    const {data: {success}} = await axios.put('/api/me/update-password', {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword,
                        confirmNewPassword: this.confirmNewPassword,
                        userData: this.user
                    });

                    if (success) {
                        this.setAlertData({type: 'primary', message: 'Parole veiksmīgi nomainīta!', dismissSecs: 5});
                        this.currentPassword = this.newPassword = this.confirmNewPassword = '';
                        this.$refs.observer.reset();
                        await this.$router.push({name: 'index'});
                    }
                } catch ({response: {data: {error}}}) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                } finally {
                    this.isActiveRequest = false;
                }
            },
        }
    }
</script>